export default {
  首页: "Casa",
  资产: "Risorse",
  币币: "Moneta",
  快捷买币: "Commercio P2P",
  "支持多种方式购买，购买更简单":
    "Supporta più modi per acquistare, acquista in modo più semplice",
  语言设置: "Impostazioni della lingua",
  确认恢复: "Conferma il recupero",
  "输入邮箱，方便我们联系您":
    "Inserisci la tua email così possiamo contattarti",
  划转: "Trasferimento",
  行情: "Citazioni",
  "24H成交": "Transazione 24 ore",
  累计收益: "Reddito cumulativo",
  充值时间: "Tempo di ricarica",
  到期时间: "Data di scadenza",
  数量: "Quantità",
  操作: "Operare",
  资产信息: "Informazioni sulle risorse",
  复制地址: "Copia",
  链名称: "Nome della catena",
  充值地址: "indirizzo di ricarica",
  收款地址: "Indirizzo di pagamento",
  账单: "Fattura",
  提现金额: "Importo di prelievo",
  接收地址: "Indirizzo di ricezione",
  交易密码: "Password della transazione",
  提现全部: "Ritira tutto",
  保存图片: "Salva immagine",
  输入您的交易密码: "Password della transazione",
  确定: "Sicuro",
  地址: "Indirizzo",
  注册时间: "Tempo del segno",
  取消: "Annulla",
  是否划转: "Se trasferire",
  登录: "Accesso",
  我的地址: "Il mio indirizzo",
  登录密码和交易密码: "Password di accesso e password di transazione",
  注册: "Registrati",
  密码: "Parola d'ordine",
  设置密码: "Impostare la password",
  重复密码: "Ripeti la password",
  新密码: "Nuova password",
  确认新密码: "Conferma la nuova password",
  充值: "Ricaricare",
  充值货币: "Ricaricare",
  合约账户充值: "Ricarica conto futures",
  账户充值: "Ricarica conto",
  其他: "Altro",
  我的邀请码: "Codice invito",
  提现: "Ritirare",
  客服: "Cliente",
  持有详情: "Dettagli di detenzione",
  请输入内容: "Si prega di inserire il contenuto",
  邀请好友来领取奖励: "Invita gli amici a ricevere ricompense",
  复制链接: "copia",
  重复设置新的密码: "Ripetere l'impostazione della nuova password",
  保存: "Salva",
  我的: "Il mio",
  "邮箱/手机号": "E-mail/Numero di cellulare",
  备注: "Nota",
  地址管理: "Il mio indirizzo",
  我的团队: "Squadre",
  联系我们: "Contattaci",
  竭诚为您服务: "Sinceramente al tuo servizio",
  提取收益: "Reddito da prelievo",
  带给我的收益: "Il mio vantaggio",
  添加: "Aggiungere",
  名称: "Nome",
  添加地址: "Aggiungi indirizzo",
  修改地址: "Cambia indirizzo",
  可提现: "Può essere ritirato",
  安全中心: "Centro di sicurezza",
  收益划转: "Trasferimento di reddito",
  通知中心: "Notifica",
  "累计收益:": "Guadagno cumulativo:",
  注册用户: "Utente registrato",
  奖励规则: "Regole di ricompensa",
  帮助反馈: "Feedback di aiuto",
  邀请好友: "Invita gli amici",
  恢复身份: "Ripristina identità",
  选择语言: "Scegli la lingua",
  设置新的密码: "Imposta nuova password",
  暂无活动: "Nessuna attività",
  "月增长量(+)": "Crescita mensile (+)",
  可提取: "Estraibile",
  反馈类型: "Tipo di feedback",
  赠送: "Regalare",
  已经复制: "copiato",
  保存成功: "Salvato con successo",
  划转成功: "Trasferimento riuscito",
  过期: "È scaduto",
  提交成功: "Inserito con successo",
  "服务器繁忙，稍后在试": "Il server è occupato, riprovo più tardi",
  全部: "Tutto",
  一级: "Livello 1",
  二级: "Livello 2",
  三级: "Livello 3",
  级: "Classe",
  删除成功: "Eliminato con successo",
  选择地址: "Scegli indirizzo",
  不再提醒: "Nessun promemoria",
  "最小充值金额：": "Ricarica minima:",
  选择币种: "Seleziona valuta",
  输入投资金额: "Importo dell'investimento",
  输入账户密码: "Parola d'ordine",
  投资: "Investire",
  订单编号: "ID ordine",
  投资周期: "Ciclo",
  投资资金: "Fondi",
  投资时间: "Volta",
  状态: "Stato",
  投资中: "Investire",
  已到期: "È scaduto",
  暂无数据: "Nessun dato",
  转入: "Trasferimento in",
  邮箱: "Posta",
  请输入邮箱: "E-mail",
  请输入格式正确的邮箱: "Indirizzo e-mail",
  请输入验证码: "Codice di verifica",
  获取验证码: "Ottenere il codice",
  请输入邀请码: "Codice invito",
  今天: "In data odierna",
  昨天: "Ieri",
  最近七天: "ultimi sette giorni",
  邀请: "Invitare",
  购买数量: "Quantità d'acquisto",
  产品详情: "Dettagli del prodotto",
  币种: "Moneta",
  利息币种: "Valuta di interesse",
  理财类型: "Tipo finanziario",
  产品费率: "Tariffa del prodotto",
  进行中: "Condotta",
  每天: "Ogni giorno",
  请输入搜索关键词: "Inserisci una parola chiave",
  通知: "Avviso",
  查看更多: "Di più",
  理财宝: "HODL & Guadagna",
  周期: "Ciclo",
  年利率: "aprile",
  更多产品: "Più prodotti",
  灵活存取: "Depositi flessibili",
  稳定收益: "Resi stabili",
  合约指南: "Centro assistenza",
  资金划转出: "Trasferimento di fondi in uscita",
  矿池收益: "Entrate del pool minerario",
  提现手续费: "Commissione di prelievo",
  冻结资金: "Blocca i fondi",
  解冻资金: "Sblocca i fondi",
  闪兑支出: "Spesa lampo",
  闪兑收入: "Reddito di scambio lampo",
  闪兑手续费: "Commissione di cambio flash",
  合约支出: "Spese future",
  合约收入: "Entrate future",
  输入的金额不可大于可用金额:
    "L'importo inserito non può essere maggiore dell'importo disponibile",
  全部兑换成功: "Con successo",
  返回: "Ritorno",
  查看历史: "Visualizza cronologia",
  闪兑历史: "Cronologia flash",
  支付: "Paga",
  获取: "Ottenere",
  时间: "Volta",
  手续费: "Commissione di gestione",
  折扣: "Sconto",
  价格: "Prezzo",
  逐仓: "Isolato",
  全仓: "Attraverso",
  市价委托: "Ordine di mercato",
  限价委托: "Ordine limite",
  请输入本金: "Quantità",
  请输入价格: "Prezzo",
  "可做空/做多": "Corto lungo",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "Costo",
  做多: "Lungo",
  做空: "Breve",
  仓位信息: "Informazioni sulla posizione",
  一键平仓: "Chiudi tutto",
  永续: "",
  浮动盈亏: "P&L",
  平仓: "Chiudere",
  反向开仓: "RVS aperto",
  一键撤销: "Annulla con un clic",
  倍杠杆: "x",
  执行价格: "Prezzo d'esercizio",
  委托数量: "Numero di ordini",
  保证金: "Margine",
  成交价: "Prezzo aperto",
  创建时间: "Data di creazione",
  撤销: "Revocare",
  合约市场: "Mercato dei futures",
  交易方向: "Direzione commerciale",
  委托价格: "Prezzo dell'ordine",
  委托金额: "Importo della commissione",
  资金费率: "Tasso di finanziamento",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Una commissione ricorrente pagata dai trader long e short, regolata ogni 8 ore.",
  "资金费率为正，多方向空方支付资金费用。":
    "Il tasso di finanziamento è positivo e il lato lungo paga la quota di finanziamento del lato corto.",
  "资金费率为负，空方向多方支付资金费用。":
    "Il tasso di finanziamento è negativo e il lato corto paga la commissione di finanziamento alle parti multiple.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Sei sicuro di voler aprire una posizione al contrario? La posizione di apertura inversa verrà acquistata con l'attuale posizione opposta",
  "仓位止盈/止损": "Posizione Take Profit/Stop Loss",
  合约名称: "Futuri",
  开仓价格: "Prezzo aperto",
  指数价格: "Prezzo indice",
  止盈设置: "Impostazione del profitto",
  请输入止盈价: "Inserisci il prezzo take profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Quando il prezzo dell'indice tocca {0}, attiverà l'ordine per chiudere la posizione",
  预计盈亏: "Qtà di liquidazione",
  当前仓位: "Posizione attuale",
  平仓金额: "Importo di liquidazione",
  仓位模式: "Modalità posizione",
  全仓模式: "Modalità magazzino completo",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Tutti i fondi disponibili nel conto futures sono considerati margini disponibili. Quando la perdita di posizione supera il saldo del conto, la posizione verrà liquidata e tutti i margini e le posizioni andranno persi. Si prega di notare che",
  逐仓模式: "Modalità margine isolato",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Farà sì che un certo importo di margine nel conto future venga allocato alla posizione. Se la perdita di margine scende al di sotto del livello del margine di mantenimento, la posizione viene liquidata. Nella modalità posizione isolata, puoi aumentare e diminuire il margine per questa posizione.",
  "是否撤销？": "È revocato?",
  "是否一键撤销？": "È un clic annulla?",
  "是否一键平仓？": "Se chiudere una posizione con un clic?",
  持仓保证金: "Margine",
  风险率: "Rischio",
  未实现盈亏: "Non attuato P&L",
  可用保证金: "Margine libero",
  净值: "Nuovo valore",
  账户余额: "Equilibrio",
  合约计算器: "Calcolatrice",
  交易记录: "Registrazione della transazione",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "P&L di chiusura:",
  时间筛选: "Filtro temporale",
  仓位类型: "Tipo di posizione",
  订单状态: "Lo stato dell'ordine",
  订单类型: "Tipo di ordine",
  平仓价格: "Prezzo di chiusura",
  持仓数量: "Quantità",
  "手续费(%)": "Commissione di gestione (%)",
  平仓时间: "Orario di chiusura",
  平仓类型: "Tipo di chiusura",
  手动平仓: "Chiudere una posizione manualmente",
  强制平仓: "Liquidazione forzata",
  近1天: "1 giorno",
  近7天: "7 giorni",
  近30天: "30 giorni",
  近180天: "180 giorni",
  持仓: "Posizione",
  已取消: "Annullato",
  分时: "Volta",
  "24H额(USDT)": "Importo 24 ore (USDT)",
  "24H低": "24H basso",
  "24H量(BTC)": "Volume 24 ore (BTC)",
  "24H高": "24 ore di altezza",
  "10秒": "10 secondi",
  "30秒": "30 secondi",
  "1分": "1 punto",
  "3分": "3 punti",
  "5分": "5 punti",
  "30分": "30 punti",
  "1小时": "1 ora",
  "4小时": "4 ore",
  "8小时": "8 ore",
  "1天": "1 giorno",
  "1周": "1 settimana",
  "1月": "Gennaio",
  单向持仓: "Posizione unidirezionale",
  杠杆: "leva",
  仓位: "Posizione",
  计算结果: "Risultati di calcolo",
  盈亏: "Profitti e perdite",
  收益率: "Tasso di rendimento",
  计算结果仅供参考: "I risultati del calcolo sono solo di riferimento",
  成交后仓位大小: "Dimensione della posizione dopo la transazione",
  "计算结果仅供参考,实际结果可能因费率差异":
    "I risultati del calcolo sono solo di riferimento, i risultati effettivi possono variare a causa delle differenze di tasso",
  目标价格: "Obbiettivo",
  开始计算: "Inizia a calcolare",
  强平价格: "Liquidazione",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Prima di effettuare la ricarica, controllare attentamente il nome della catena di ricarica. Se la ricarica è errata, i beni non possono essere recuperati. {0}L'importo minimo di ricarica è {1}; se l'importo è inferiore a tale importo, la piattaforma non sarà in grado di confermare la ricezione. Si prega di non ricaricare asset diversi da {2} a questo indirizzo, altrimenti non sarà possibile recuperare gli asset, si prega di non prelevare direttamente l'indirizzo crowdfunding o ICO, la piattaforma non fungerà da proxy per l'emissione di token.",
  "最小输入*": "Minimo {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "L'importo minimo di prelievo è {0}, la commissione di prelievo verrà detratta dall'importo di prelievo. Prima di prelevare le monete, si prega di confermare e controllare l'indirizzo di ricezione, e non prelevare {1}ad un indirizzo diverso da {2}, altrimenti i beni non verranno recuperati in affitto non ritirare direttamente il crowdfunding o l'indirizzo ICO, la piattaforma non gestirà l'emissione di token.",
  退出登录: "disconnessione",
  加仓: "Aggiungere",
  新增仓位: "Aggiungere",
  输入加仓金额: "Inserisci l'importo",
  "当前可用:": "Attualmente disponibile:",
  资产账单: "Conto patrimoniale",
  保存二维码: "Salvare",
  温馨提示: "Consigli gentili",
  "请注意：您当前使用的网络": "Nota: la tua rete attuale",
  输入提现地址: "Inserisci l'indirizzo per il ritiro",
  "可用金额：": "Importo disponibile:",
  输入资产密码: "Password della risorsa",
  可用手续费: "Tariffa di gestione disponibile",
  "折扣%": "Sconto%",
  实扣手续费: "Tassa di detrazione effettiva",
  实际到账: "Credito effettivo",
  未设置资产密码: "Password della risorsa non impostata",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Per la sicurezza dei tuoi beni, ti preghiamo di impostare la password del bene prima di ritirare.",
  热榜: "Piccante",
  涨幅榜: "Salita",
  跌幅榜: "Perdente",
  成交额榜: "Turnover",
  关于我们: "Chi siamo",
  登录密码: "Password per il login",
  设置: "Impostare",
  资产密码: "Password della risorsa",
  修改登录密码: "Modifica la password di accesso",
  原密码: "Vecchia password",
  请输入新密码: "Nuova password",
  请输入原密码: "Password originale",
  确认密码: "Conferma password",
  确定修改: "OK per modificare",
  修改资产密码: "Modifica la password della risorsa",
  验证码: "Codice di verifica",
  资产密码使用提示: "Suggerimenti per l'utilizzo della password della risorsa",
  "资产密码用于转移、提取资产和交易。":
    "La password dell'asset viene utilizzata per trasferire, prelevare asset e fare trading.",
  "创建与登录密码不同的资产密码。":
    "Crea una password per la risorsa diversa dalla password di accesso.",
  "定期更改您的资产密码。":
    "Cambia regolarmente la password della tua risorsa.",
  提币历史: "Cronologia dei prelievi",
  "金额/余额": "Importo/Saldo",
  "手续费/折扣": "Spese di gestione/sconto",
  自选: "Opzionale",
  现货: "Macchiare",
  市价: "Prezzo di mercato",
  止损设置: "Arresta l'impostazione della perdita",
  合约K线图: "Grafico a linee K futures",
  "24H量": "Volume 24 ore",
  "24H额": "Importo 24 ore",
  合作指南: "Guida alla cooperazione",
  盈亏计算: "P&L",
  当前可用: "Attualmente disponibile",
  请输入加仓金额: "Si prega di inserire l'importo dell'aumento",
  请重新输入加仓金额: "Si prega di inserire nuovamente l'importo dell'aumento",
  平仓数量: "Numero di chiusi",
  欢迎登录: "Accedi per favore",
  "忘记密码?": "Ha dimenticato la password?",
  "还没有账号？": "Non hai ancora un conto?",
  立即注册: "Iscriviti ora",
  繁體中文: "Cinese tradizionale",
  找回密码: "Recupera password",
  下一步: "Passo successivo",
  注册账户: "Registra account",
  "请输入邀请码(选填)": "Codice invito (opzionale)",
  谢邀豪礼: "Invito",
  "24小时邀请好友排名": "24 ore invitare la classifica degli amici",
  "*人": "{0}",
  "差*人": "{0}Spazio",
  "已超过10万人，每月轻松赚钱":
    "Ha più di 100.000 persone, guadagna facilmente ogni mese",
  最高: "Più alto",
  邀请链接: "Collegamento",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "La piattaforma e tu condividi le commissioni generate dai tuoi amici sulla piattaforma (potenze, leva, scambio flash)",
  平台和您一起分享手续费: "Condividi la quota insieme",
  "*级": "{0}livello",
  规则: "Regola",
  我的好友: "Gli amici",
  好友详情: "Dettagli dell'amico",
  获得好友佣金方案: "Ottieni il programma della commissione degli amici",
  我的等级: "Il mio livello",
  我的邀请数据: "I miei dati di invito",
  当前等级: "Livello attuale",
  平台奖励您: "La piattaforma ti premia",
  最高可获取平台奖励: "Massima ricompensa disponibile",
  邀请规则: "Regole di invito",
  "邀请*级有效好友": "Invita amici validi di livello {0}",
  好友等级: "Livello amico",
  人: "Le persone",
  奖金派送: "Consegna bonus",
  平台奖励: "Ricompensa della piattaforma",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Il diritto di interpretazione finale appartiene alla piattaforma. Se viene rilevato che i premi della piattaforma vengono ottenuti in modo anomalo, tutti i premi verranno detratti e l'account verrà bloccato e tali risorse non verranno recuperate.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Il tuo account deve essere un account valido e la piattaforma determina che la condizione dell'account valido è (l'account viene ricaricato in qualsiasi valuta) il valore minimo di {0} USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Gli amici che inviti devono essere subordinati validi. I platforeterminas che i subordinati validi sono (ricarica del conto in qualsiasi valuta) valore minimo {0} USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Gli account dell'invitante e dell'invitato non possono appartenere allo stesso IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Il livello VIP è valutato dal numero di amici di alto livello che inviti.",
  佣金成分: "Componente della Commissione",
  收益统计: "Statistiche sul reddito",
  昨日收益: "di ieri",
  月收益: "Mensile",
  获取收益: "Reddito",
  "总收益：": "Totale:",
  "*级好友": "{0}amico di livello",
  理财购买: "Acquisto finanziario",
  期限: "Il termine",
  可用金额: "Importo disponibile",
  预估收益: "Guadagni stimati",
  申购上限: "Limite di abbonamento",
  项目剩余: "Progetto rimanente",
  "买入后预计*(SGT)开始计算收益。":
    "Aspettati che {0}(SGT) inizi a guadagnare.",
  计息日: "Data di interesse",
  申购日: "Acquista data",
  到账日: "Data d'arrivo",
  到期自动续投: "Rinnovo automatico dopo la scadenza",
  申购: "Sottoscrizione",
  搜索理财项目: "Cerca programmi finanziari",
  超高年化随心选: "Scelta libera",
  "自由选择理财币种，稳定超额收益":
    "Libera scelta della valuta di gestione patrimoniale per stabilizzare i rendimenti in eccesso",
  理财总资产: "Importo dell'acquisto",
  累计收益: "Reddito cumulativo",
  申购数量: "",
  立即购买: "Acquista ora",
  年化收益率: "aprile",
  理财订单: "Ordine finanziario",
  持有: "Presa",
  申购份额: "Quota di abbonamento",
  到账日期: "Data d'arrivo",
  申购成功: "L'abbonamento è andato a buon fine",
  到期: "Scadenza",
  是否选择做多: "Scegli di fare di più",
  "可用余额为0 不能操作":
    "Il saldo disponibile è 0 e non può essere utilizzato",
  福利中心: "omaggi",
  奖励记录: "Disco",
  我获取到的奖励: "Ricompense che ho ricevuto",
  总价值: "Valore totale",
  新手任务: "Compito da principiante",
  身份认证: "Autenticazione",
  身份验证: "Autenticazione",
  去验证: "Verificare",
  审核中: "In corso di revisione",
  已验证: "Verificato",
  认证失败: "Autenticazione fallita",
  基础认证: "Certificazione di base",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Si prega di notare che le informazioni di autenticazione non possono essere modificate una volta verificate, assicurarsi di inserire le informazioni corrette",
  "国家/地区": "Paese/regione",
  请选择: "Si prega di scegliere",
  证件类型: "Tipo di certificato",
  证件编码: "Codifica",
  身份证: "carta d'identità",
  护照: "Passaporto",
  驾驶证: "Patente di guida",
  请输入编码: "Si prega di inserire il codice",
  名字: "Nome",
  请输入: "Prego entra",
  中间名: "Secondo nome",
  选填: "Opzionale",
  姓氏: "cognome",
  中国: "Cina",
  身份上传: "Caricamento identità",
  上传身份证: "Carica ID",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "I materiali di cui sopra devono essere caricati in JPG/JPEG/PNormata e assicurarsi che i bordi e gli angoli chiari della foto siano completi e la luminosità sia uniforme. E la dimensione non supera {0}M.",
  确定提交: "Conferma invio",
  去认证: "Disautenticazione",
  挑战任务: "Missione sfida",
  注册认证任务: "Registrati per attività di certificazione",
  完成注册认证即可领取:
    "Dopo aver completato la certificazione di registrazione, puoi riceverla",
  领取奖励: "Ricevi premio",
  新人豪礼: "Regalo del nuovo arrivato",
  "参与人数：": "Il numero dei partecipanti:",
  条件: "Condizione",
  入金量: "Depositare",
  完成: "Fine",
  任务奖励: "Ricompense della missione",
  距任务更新: "Aggiorna dall'attività",
  "条件：": "Condizione:",
  活动规则: "Regola di attività",
  奖励明细: "Dettagli sulla ricompensa",
  已获得: "Ottenuto",
  交易奖励: "Ricompensa della transazione",
  Win奖励: "Vinci premi",
  已领取: "Ricevuto",
  亏损金额超过: "L'importo della perdita supera",
  单笔开仓金额超过: "L'importo di una singola posizione aperta supera",
  交易量: "Commercio",
  待完成: "In attesa di",
  入金: "Depositare",
  盈利金额超过: "L'importo del profitto supera",
  开仓金额: "Quantità",
  开仓金: "Posizione aperta",
  盈利: "Profitto",
  亏损: "perdita",
  领取: "Ricevere",
  未领取: "Inaccettabile",
  待领取: "In attesa di",
  再交易: "Rinegoziazione",
  即可获得: "Ottenere",
  领取成功: "Ricevuto con successo",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Tutte le attività verranno conteggiate in base all'ultima volta dell'attività e non saranno valide dopo la scadenza.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Il reddito ottenuto verrà distribuito sul tuo conto bounty, e yoaexchange e prelevarlo in qualsiasi momento in base alle tue esigenze.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Il tipo di valuta premio ottenuta verrà emessa in base al tipo di attività.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Il diritto di interpretazione finale spetta alla piattaforma. Se si scopre che ci sono mezzi anormali per arbitrare il bonus attività della piattaforma, la piattaforma ha il diritto di bloccare e cancellare il reddito che hai ottenuto.",
  成长学院: "Aiuto",
  "区块链 & 加密货币": "Blockchain e criptovaluta",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "La tua guida unica alle criptovalute, ti portiamo sulla strada delle criptovalute.",
  "全仓合约定单的全部保证金。":
    "Il margine completo per un ordine cross futures.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (P&L non realizzati - commissione di gestione - commissione overnight) = nuovo valore/margine utilizzato * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'Il P&L non realizzato influirà direttamente sul "margine disponibile". Quando il profitto e la perdita non realizzati aumentano, il margine disponibile aumenterà e il profitto e la perdita non realizzati aumenteranno e anche il margine disponibile diminuirà.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (margine utilizzato) + (P&L non realizzati - commissione di gestione - commissione overnight)",
  "注:可继续用于开仓的保证金。":
    "Nota: Margine che può continuare ad essere utilizzato per le posizioni di apertura.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (P&L non realizzati - commissione di gestione - commissione overnight)",
  "注:当前的资金结余。": "Nota: saldo attuale del fondo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Si riferisce all'intero saldo del conto future, incluso il saldo non disponibile.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Nota: maggiore è il tasso di rischio, minore è il rischio e minore è il tasso di rischio, maggiore è questo.",
  该功能尚未开发: "Questa funzione non è stata sviluppata",
  重置密码: "Resetta la password",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Inserisci 8-20 caratteri, deve contenere lettere, numeri e caratteri speciali",
  修改成功: "Modificato con successo",
  输入验证码: "Codice",
  输入密码: "Parola d'ordine",
  详情说明: "Particolari",
  已售罄: "Venduto",
  剩余期限: "Scadenza",
  限期: "Scadenza",
  闪兑货币选择: "Selezione valuta flash",
  地区选择: "Selezione della regione",
  "搜索国家/地区": "Cerca paese",
  "身份信息已提交，将在*小时内审核完成":
    "Le informazioni sull'identità sono state inviate e verranno esaminate entro {0} ore",
  "选择国家/地区": "Seleziona il paese",
  "止盈价格需高于*": "Il prezzo Take Profit deve essere superiore a {0}",
  "止损价格需低于*": "Il prezzo dello stop loss deve essere inferiore a {0}",
  "止盈价格需低于*": "Il prezzo Take Profit deve essere inferiore a {0}",
  "止损价格需高于*": "Il prezzo dello stop loss deve essere superiore a {0}",
  教程详情: "Dettagli del tutorial",
  请输入止损价: "Inserisci un prezzo stop loss",
  活期: "Flessibile",
  赎回后立即到账: "Ritirare",
  赎回: "Redenzione",
  赎回理财: "Redenzione",
  是否赎回当前的理财订单:
    "Se riscattare l'attuale ordine di gestione patrimoniale",
  维护: "Manutenzione",
  "系统正在维护中……": "L'impianto è in manutenzione...",
  合约: "Futuri",
  闪电兑换: "Scambio",
  流水挖矿: "Estrazione delle nuvole",
  邀请豪礼: "Invito",
  计算器: "Calcolatrice",
  最新价: "Ultimo prezzo",
  涨跌幅: "Modificare",
  关注币种添加自选: "Segui la valuta",
  一键添加自选: "Aggiungere",
  全标已读: "Leggi tutto",
  无消息: "Nessuna novità",
  "暂时还没有收到任何消息通知哦!": "Nessun messaggio ricevuto!",
  没有更多数据: "Non più",
  闪兑: "Scambio",
  从: "Da",
  "可用余额：": "Equilibrio:",
  至: "Per",
  预览兑换结果: "Anteprima",
  闪兑规则: "Regole",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Lo scambio flash di mercato può variare, fare riferimento all'importo effettivamente ricevuto.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Il tasso di cambio è fissato da una terza parte. A causa dei costi di cambio e delle fluttuazioni del mercato, il tasso di cambio scambiato potrebbe essere superiore al tasso di cambio del mercato. Si prega di confermare con attenzione prima di procedere.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "La piattaforma addebita una commissione di gestione di circa il {fee}% per ogni scambio, che viene utilizzato come costo di scambio nello scambio.",
  确认汇兑: "Confermare",
  您预估得到: "Stima",
  汇兑: "Scambio",
  汇兑比例: "Proporzione",
  刷新: "ricaricare",
  兑换: "Scambio",
  没有更多了: "Non più",
  搜索币种: "Ricerca",
  可用: "A disposizione",
  我知道了: "Sapere",
  最新价格: "Ultimo prezzo",
  确认: "Confermare",
  最大: "Max",
  "风险率(%)": "Rischio(%)",
  持仓: "Posizione",
  当前委托: "Ordine",
  合作交易历史记录: "Storia",
  重置: "Ripristina",
  余额: "Equilibrio",
  现货账户: "Conto di finanziamento",
  合约账户: "Futuri",
  WIN账户: "Vincita",
  赏金账户: "Regalo",
  总资产折合: "Equivalente del bene",
  今日收益: "Di oggi",
  充币: "Depositare",
  提币: "Ritirare",
  账户权益: "Patrimonio netto",
  "数量/类别": "Importo/Tipo",
  全部币种: "Tutte le monete",
  全部类型: "Tutti i tipi",
  账单信息: "Moneta",
  理财赎回: "Riscatto finanziario",
  购买理财: "Acquisto finanziario",
  收入: "Reddito",
  支出: "Spese",
  到: "Per",
  资产划转: "Trasferimento",
  "最少*": "Min*",
  "可用资产：": "Equilibrio",
  确认划转: "Trasferimento",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Le transazioni possono essere eseguite solo trasferendo beni al conto corrispondente e non verrà addebitata alcuna commissione di gestione per i trasferimenti tra conti.",
  币种账户选择: "Scelta dell'account",
  选择账户: "Scelta dell'account",
  划转详情: "Informazioni sul trasferimento",
  划转明细: "Informazioni sul trasferimento",
  收入账单: "Informazioni sul reddito",
  支出账单: "Informazioni sulle spese",
  金额: "Quantità",
  总收益: "Totale",
  佣金: "Premio",
  用户名: "nome utente",
  "已领取：": "Ricevuto:",
  "未领取：": "Non ricevuto:",
  "请选择国家/地区": "Si prega di selezionare il paese/regione",
  请上传身份信息: "Si prega di caricare l'ID",
  请选择证件类型: "Seleziona il tipo di documento",
  请填写证件编码: "Si prega di compilare il numero ID",
  请填写名字: "Si prega di compilare il nome",
  请填写姓氏: "Si prega di inserire il cognome",
  单向持仓: "Tenuta unidirezionale",
  投资金额: "Quantità",
  天: "giorno",
  请输入手机号: "Telefono",
  搜索: "Ricerca",
  搜索历史: "Cronologia delle ricerche",
  热门推荐: "Piccante",
  "《Xspace Earn协议》": "《Protocollo Guadagna Xspace》",
  我已了解并同意: "Capisco e concordo",
  协议: "protocollo",
  Xspace官方中文交流群: "Gruppo cinese ufficiale di Xspace",
  Xspace官方英文交流群: "Gruppo inglese ufficiale di Xspace",
  预计维护至: "Previsto",
  更多功能: "Di più",
  下载APP: "Scarica",
  理财: "Finanziario",
  推荐: "Consiglia",
  Telegram官方中文频道: "Canale cinese ufficiale di Telegram",
  Telegram官方英文频道: "Canale inglese ufficiale di Telegram",
  官方邮箱: "E-mail ufficiale",
  客服邮箱: "E-mail del servizio clienti",
  上述信息最终解释权归官方所有:
    "Il diritto di interpretazione finale spetta al funzionario",
  IOS版下载: "Scarica per iOS",
  Android版下载: "Scarica per Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Commissione = Commissione di acquisto + Commissione di fondi + Commissione di vendita",
  资金划转: "Trasferimento",
  止盈: "TP",
  止损: "SL",
  自动平仓: "Chiusura automatica",
  委托挂单: "Ordine in attesa di affidamento",
  买: "Acquistare",
  卖: "Vendere",
  "买入/做多": "Compra/Lungo",
  "卖出/做空": "Vendi/A corto",
  详情: "Particolari",
  浮动涨跌: "Alti e bassi",
  最小: "Min",
  充币数量: "Importo di ricarica",
  请输入充币数量: "Importo di ricarica",
  支付截图: "Screenshot di pagamento",
  提交: "Sottoscrivi",
  上传驾驶证: "Carica la patente di guida",
  上传护照: "Carica passaporto",
  加载中: "Caricamento in corso",
  上传成功: "Successo",
  充值历史: "Storia",
  合约卖出手续费: "Canone contrattuale",
  合约买入手续费: "Canone contrattuale",
  系统加款: "Componente aggiuntivo di sistema",
  系统减款: "Riduzione del sistema",
  合约资金费率: "Tariffa contrattuale",
  佣金分成: "Quota della Commissione",
  U本位合约: "Contrarre",
  资产管理: "Risorse",
  APP下载: "Download dell'APP",
  全球领先的数字理财平台:
    "La piattaforma di gestione patrimoniale digitale leader al mondo",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Scambia istantaneamente centinaia di risorse digitali come Bitcoin ed Ethereum",
  "24H涨跌幅": "Cambio 24 ore",
  查看更多行情: "Visualizza più citazioni",
  近24小时成交量: "Volume nelle ultime 24 ore",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Fornisci centinaia di coppie di valute e contratti per soddisfare esigenze di trading diversificate. La piattaforma conta oltre 20 milioni di utenti in 200 paesi e regioni ed è la piattaforma di servizi di asset digitali leader al mondo.",
  用户国家分布: "Distribuzione del paese dell'utente",
  用户数: "Numero utente",
  交易对: "Coppia di scambio",
  服务支持: "Servizio di supporto",
  "随时随地，多平台终端交易":
    "Transazioni terminali multipiattaforma sempre e ovunque",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Il multi-terminale è perfettamente compatibile e può soddisfare in qualsiasi momento le esigenze di transazione di vari scenari.",
  随时查看实时行情:
    "Visualizza le quotazioni in tempo reale in qualsiasi momento",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Acquista e vendi facilmente BTC, ETH, DOGE e altre risorse digitali",
  获取您关注的加密货币价格变化预警:
    "Ricevi avvisi sulle variazioni di prezzo delle criptovalute che ti interessano",
  "查看比特币现货、期货、期权价格":
    "Visualizza i prezzi spot, future e opzioni di Bitcoin",
  比较各交易所加密货币价格:
    "Confronta i prezzi delle criptovalute tra gli exchange",
  开启您的数字货币之旅: "Inizia il tuo viaggio nella valuta digitale",
  快捷购买数字货币: "Acquista rapidamente valuta digitale",
  "使用多种支付方式交易数字货币，安全快捷":
    "Usa una varietà di metodi di pagamento per fare trading di valuta digitale, in modo sicuro e veloce",
  最优的交易费率: "miglior tasso di transazione",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tassi di transazione preferenziali, diritti VIP competitivi, goditi il ​​miglior servizio di qualità",
  可信赖的安全保障: "Sicurezza affidabile",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Le nostre sofisticate misure di sicurezza e i fondi SAFU proteggono le tue risorse digitali da tutti i rischi.",
  交易: "Commercio",
  币币市场: "Mercato valutario",
  "24H成交量": "Volume 24 ore",
  交易所: "Scambio",
  "24H最高": "Alta 24 ore",
  "24H最低": "Basso 24 ore",
  永续合约: "Contratto perpetuo",
  日涨跌: "Modificare",
  交易深度: "profondità della transazione",
  "资产(合约)": "Attività (Contratti)",
  历史仓位: "Storico",
  兑换记录: "Record di scambio",
  类型: "Tipo",
  充值记录: "Registro di ricarica",
  划转记录: "Record di trasferimento",
  类别: "Categoria",
  历史账单: "Storico",
  在线充值: "Ricaricare",
  安全设置: "Impostazioni di sicurezza",
  用于账户登录使用: "Per l'uso dell'accesso all'account",
  用户提现时安全验证使用:
    "Verifica della sicurezza e utilizzo quando gli utenti prelevano contanti",
  验证: "Verificare",
  万: "Dieci mila",
  随时随地开启交易: "Commercio. Ovunque.",
  "*货币交易所的所有功能尽在你的手中。":
    "Tutte le funzioni di {0} cambio valuta sono nelle tue mani.",
  "下载*货币交易所APP。": "Scarica l'APP per il cambio valuta {0}.",
  下载自: "Scarica da",
  内测版: "Beta chiusa",
  下载: "Scarica",
  扫码下载: "Scansione per scaricare",
  设置您的资产密码: "Imposta la password della tua risorsa",
  法币: "Fiat",
  我要买: "Acquista",
  我要卖: "Vendere",
  请输入金额: "Si prega di inserire l'importo",
  汇率: "Tasso di cambio",
  获得: "Ottenere",
  支付通道: "Canale di pagamento",
  收款通道: "Canale di raccolta",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Durante il processo di vendita, devi confermare che il tuo metodo di pagamento è tuo.",
  当前法币暂不支持交易对可尝试前往提现:
    "L'attuale valuta legale non supporta la coppia di trading, puoi provare a ritirare",
  前往提现: "Vai a incassare",
  该法币暂无通道: "Al momento non esiste un canale per questa valuta fiat",
  "正在出售中，请耐心等待": "In vendita, per favore sii paziente",
  请选择支付通道: "Seleziona un canale di pagamento",
  请选择方式: "Seleziona un metodo",
  法币历史: "Storia Fiat",
  买币: "Comprare monete",
  卖币: "Vendere monete",
  失败: "Fallire",
  已完成: "Completato",
  未付款: "Non pagato",
  待审核: "Revisione in atto",
  打款中: "Pagare",
  订单详情: "Dettagli dell'ordine",
  联系客服: "Contattare il Servizio Clienti",
  到账金额: "Quantità ricevuta",
  通道: "Corridoio",
  收款人: "Beneficiario",
  收款账户: "Crediti",
  "订单出售失败，请查下方失败原因":
    "L'ordine non è stato venduto, controlla il motivo dell'errore di seguito",
  失败原因: "Motivo del fallimento",
  您还未进行付款: "Non hai effettuato un pagamento",
  您已成功购买: "Hai acquistato con successo",
  已取消订单: "Ordine cancellato",
  "订单正在审核中，请耐心等待":
    "L'ordine è in fase di revisione, si prega di pazientare",
  您已成功出售: "Hai venduto con successo",
  "订单正在打款中，请耐心等待":
    "L'ordine è in corso di pagamento, si prega di pazientare",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Il processo di pagamento richiede di andare su altre piattaforme per pagare gli ordini, si prega di prestare attenzione alla sicurezza delle informazioni.",
  当前法币暂不支持交易对可尝试前往充值:
    "L'attuale valuta fiat non supporta le coppie di scambio, puoi provare a ricaricare",
  前往充值: "Vai a ricaricare",
  购买: "Acquistare",
  订单号: "Ordine ID",
  单价: "Prezzo unitario",
  到账数量: "Importo da contabilizzare",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Ci sono attualmente ordini non pagati, vuoi continuare ad avviare un nuovo ordine di pagamento?",
  继续支付: "Continuare a pagare",
  重新下单: "Riordina",
  是否确定出售: "Sei sicuro di vendere",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Dopo la conferma della vendita, la piattaforma verrà assegnata all'acquirente, attendere pazientemente che la piattaforma corrisponda.",
  出售: "Vendere",
  收款方式: "Metodo di pagamento",
  订单已生成: "L'ordine è stato generato",
  取消订单: "Annulla Ordine",
  请在: "Per favore a",
  内完成付款: "Completare il pagamento entro",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Lascia la piattaforma, accedi al pagamento che hai specificato, trasferisci all'account del venditore di seguito e assicurati di annotare nel pagamento:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Se non vengono fatte osservazioni al momento del pagamento, il venditore non potrà confermare il pagamento, con conseguente perdita di beni che non possono essere recuperati.",
  "未在规定的时间内付款，订单都将被取消。":
    "In caso di mancato pagamento nei termini previsti, l'ordine verrà annullato.",
  姓名: "Nome",
  收款姓名: "Nome del beneficiario",
  开户支行: "Filiale di apertura conto",
  银行卡号: "Numero di carta bancaria",
  "付款后，返回本平台": "Dopo il pagamento, torna su questa piattaforma",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'Assicurati di fare clic sul pulsante "Ho completato il pagamento, avvisa il venditore" di seguito',
  未点击卖家不会放款: "Se non fai clic, il venditore non rilascerà il denaro",
  交易条款: "Termini della transazione",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Acquistando la fonte dei fondi, devi disporre di fondi legali e sicuri prima di poter fare trading",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Non sono consentite frodi, schemi piramidali, gioco d'azzardo o altre transazioni finanziarie illegali",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Dopo che la transazione è stata completata, c'è il rischio di fondi, congelati o sospettati di frode, schemi piramidali, fondi di gioco d'azzardo, non rilasceremo U all'acquirente e rimborseremo",
  "已付款，通知卖家": "pagato, avvisare il venditore",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Se l'acquirente annulla {0} ordini lo stesso giorno, la funzione di acquisto lo stesso giorno verrà annullata. Sei sicuro di voler annullare questo ordine?",
  添加收款方式: "Aggiungi un metodo di pagamento",
  是否删除此收款方式: "Se eliminare questo metodo di pagamento",
  删除: "Elimina",
  请选择法币: "Seleziona la valuta fiat",
  机构名称: "Nome dell'istituto",
  请选择机构: "Seleziona un istituto",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Quando vendi valuta digitale, il metodo di pagamento che hai selezionato verrà mostrato all'acquirente, per favore conferma che sia stato compilato correttamente.",
  请选择银行: "Seleziona una banca",
  请输入姓名: "Per favore digita il tuo nome",
  账号: "Account",
  请输入账号: "Si prega di inserire l'account",
  收款码: "Codice scontrino",
  "银行账号/卡号": "Numero di conto bancario/carta",
  "请输入银行账号/卡号":
    "Si prega di inserire il numero di conto bancario/carta",
  "开户支行（选填）": "Filiale di apertura conto (opzionale)",
  请输入开户支行: "Si prega di inserire la filiale di apertura del conto",
  "加入*官方频道": "Unisciti al {0} Canale ufficiale",
  关于: "Di",
  条款: "Termini",
  其他: "Altro",
  成功: "Successo",
  等待: "Aspettare",
  作废: "Vuoto",
  确认付款: "Confermare il pagamento",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Il pagamento è stato effettuato? Se il pagamento viene confermato, il commerciante confermerà se il pagamento è stato ricevuto entro {0} minuti.",
  最大金额: "Importo massimo",
  最小金额: "Quantità minima",
  付款: "Pagamento",
  法币充值: "Ricarica valuta Fiat",
  法币提现: "Ritiro Fiat",
  待支付: "Essere pagato",
  已支付: "Pagato",
  商户名: "Mercante",
  当前没有添加支付方式:
    "Al momento non sono stati aggiunti metodi di pagamento",
  添加后再出售: "Aggiungi per vendere",
  新人大礼包: "Regalo per i nuovi arrivati",
  注册即可领取: "Registrati per ricevere",
  立即领取: "Prendilo subito",
  不再提示: "Non ricordarmelo dinuovo",
  "该奖励需在APP中领取，请下载APP":
    "Il premio deve essere raccolto nell'APP, scarica l'APP",
  去交易: "Commercio",
  期权交易: "Trading di opzioni",
  交易额: "Importo della transazione",
  可用额度: "Quota disponibile",
  交易周期: "Ciclo di negoziazione",
  看涨: "Salita",
  看跌: "Autunno",
  当前持有: "Possedimenti attuali",
  胜率: "Tasso di vincita",
  "盈利/亏损数": "Profitto/perdita",
  累计实现盈亏: "Profitti e perdite accumulati",
  秒: "Secondi",
  分: "Minuto",
  小时: "Ora",
  天: "Giorni",
  周: "Settimana",
  下单时间: "Tempo dell'ordine",
  剩余时间: "Tempo rimasto",
  买入价: "Prezzo di acquisto",
  结算价: "Prezzo di liquidazione",
  实现盈利: "Profitto",
  结算时间: "Tempo di regolamento",
  期权: "Opzioni",
  新手教程: "Tutorial per principianti",
  我的订单: "Ordine",
  赔率: "Probabilità",
  全部订单: "Tutti gli ordini",
  持有订单: "Mantieni l'ordine",
  历史订单: "Cronologia ordini",
  输入交易额度: "Inserisci l'importo",
  选择交易周期: "Periodo di selezione",
  去注册: "Registrati",
  冻结: "Congelare",
  期权支出: "Pagamento opzione",
  期权收入: "Reddito da opzioni",
  用户提现: "Recesso dell'utente",
  "是否购买？": "Vuoi comprare?",
  购买成功: "Acquisto riuscito",
  请签名: "Firmare, per favore",
  提交签名: "Sottoporre la firma",
  清空签名: "Firma chiara",
  签名审核中: "Revisione della firma",
  已提交: "Presentato",
  扫一扫下载APP: "Scansiona e scarica l'APP",
  新手领取大礼包: "I nuovi arrivati ricevono baldoria",
  注册实名即送彩金: "Registrazione e bonus nome reale",
  交易总额: "Transazione totale",
  资产不足: "Risorse insufficienti",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Gli asset nel conto Win sono insufficienti e possono essere trasferiti dal conto di finanziamento a questo conto",
  Win: "Win",
  在线充值: "Ricarica online",
  比赛: "Concorso",
  未开始: "Non iniziato",
  赛程: "Programma",
  赛果: "Risultato",
  已结束: "Sopra",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "Gioco disegnato",
  投注: "Scommesse",
  下注金额: "Importo della scommessa",
  下注: "Scommesse",
  阵容: "Allineare",
  分析: "Analizzare",
  输入下注金额: "Si prega di entrare",
  下注成功: "Scommessa riuscita",
  投注记录: "Record di scommesse",
  未结算: "Nessun insediamento",
  已结算: "Sistemato",
  流水: "Quantità",
  输赢: "W/L",
  赛时: "Tempo di gioco",
  下注时间: "Tempo di scommesse",
  足彩竞猜: "Quiz sul calcio",
  查看详情: "Dai un'occhiata",
  输: "Perdere",
  赢: "Vincita",
  主: "Squadra di casa",
  客: "Squadra in trasferta",
  主胜: "Vince la squadra di casa",
  客胜: "Vince la squadra in trasferta",
  平: "Disegnato",
  已延期: "Rinviato",
  账号异常: "Eccezione dell'account",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "Obiettivi totali",
  拍摄照片要求: "Requisiti fotografici",
  标准拍摄: "Tiro standard",
  边框缺失: "Confine mancante",
  照片模糊: "La foto è sfocata",
  闪光强烈: "Lampo forte",
  上传手持证件照: "Carica documenti palmari",
  上传证件照: "Carica foto d'identità",
  换一张: "Cambiarne",
  出生日期: "Data di nascita",
  请选择出生日期: "Si prega di selezionare la data di nascita",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Dopo aver inserito la corretta verifica grafica di seguito, ottieni il codice di verifica e-mail per la registrazione",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Hai {0} certificazioni rimanenti, dopodiché non potrai continuare la certificazione",
  上半场: "Prima metà",
  下半场: "Seconda metà",
  独赢: "1x2",
  上半场独赢: "Prima metà 1x2",
  下半场独赢: "Seconda metà 1x2",
  上半场让球: "Prima metà Handicap",
  下半场让球: "Seconda metà Asian handicap",
  上半场大小球: "Prima metà Over/Under",
  下半场大小球: "Seconda metà Over/Under",
  波胆: "Correct Score",
  上半场波胆: "Prima metà Correct Score",
  下半场波胆: "Seconda metà Correct Score",
  单双: "Odd/Even",
  上半场单双: "Prima metà Odd/Even",
  下半场单双: "Seconda metà Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "Prima metà Total Goal",
  下半场总进球: "Seconda metàTotal Goal",
  单: "Odd",
  双: "Even",
  中场: "Centrocampo",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Nota: seguire questa immagine di esempio per scrivere il testo su carta bianca e scattare la foto con la carta d'identità",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Di recente è stato scoperto un gran numero di account fraudolenti e diversi account illegali sono stati puniti. In caso di valutazione errata come account illegale, contattare il servizio clienti online.",
  最小下注金额: "Importo minimo della scommessa",
  参与活动最小下注金额:
    "Importo minimo della scommessa per partecipare all'evento",
  记住密码: "Ricordare la password",
  比分: "Punto",
  "您还未登录，请先登录": "Accedere prego",
  立即登录: "Login",
  下注限额: "Limite di puntata",
  可赢金额: "Importo vincibile",
  闪兑详情: "Dettagli flash",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "A causa del tasso di cambio, ci sarà una differenza tra l'importo della scommessa e l'importo effettivo della scommessa, fare riferimento all'ordine.",
  开赛时间: "Ora di inizio",
  足球收入: "Reddito da calcio",
  足球支出: "Spesa calcistica",
  活动详情: "Dettagli attività",
  为世界杯喝彩: "In bocca al lupo per i Mondiali",
  我的竞猜: "Mio",
  "竞猜比赛、有机会瓜分*USDT":
    "Indovina il gioco e avrai la possibilità di condividere {0}USDT",
  "瓜分*USDT": "Condividi {0}USDT",
  距离活动结束还有: "Fine della distanza",
  我的门票: "Il mio biglietto",
  竞猜结束时间: "Indovina l'ora di fine",
  猜比分: "Indovina il punteggio",
  "福利派送中，完成任务即可获取门票":
    "La distribuzione del benessere è in corso, completa l'attività per ottenere i biglietti",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Completa le seguenti attività, puoi ottenere il numero corrispondente di biglietti per partecipare al concorso",
  时: "Ora",
  活动: "Attività",
  竞猜记录: "Indovina il record",
  结果: "Risultato",
  任务: "Compito",
  去邀请: "Invitare",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Il punteggio di ogni partita è indovinato, e ${0} può essere diviso in premi per la partecipazione al concorso.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "La partecipazione al quiz richiede i biglietti, che possono essere ottenuti in base ai compiti della piattaforma.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Dopo il successo della concorsa, invia lo screenshot dei risultati al servizio clienti, che addebiterà il bonus al tuo conto e potrai prelevare immediatamente.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Qualsiasi imbroglio è proibito e le ricompense saranno annullate se viene scoperto un imbroglio.",
  "完成任务后，点击咨询客服获得门票。":
    "Dopo aver completato l'attività, fai clic su Consulta il servizio clienti per ottenere il ticket.",
  继续猜: "Continua a indovinare",
  总单数: "Singolare totale",
  赛事筛选: "Proiezione dell'evento",
  球队筛选: "Selezione della squadra",
  总金额: "Forfettario",
  总流水: "Ricambio totale",
  派奖金额: "Importo del bonus",
  下注单数: "Numero d'ordine",
  利润: "Profitto",
  更多福利: "Benessere",
  我的奖金: "Bonus",
  未认证: "Non certificato",
  总量: "Totale",
  或: "oppure",
  模拟交易: "Commercio dimostrativo",
  体验账户不可操作: "L'account Esperienza non è operativo",
  世界杯比分竞猜: "Indovina il punteggio",
  "领*USDT起": "Da {0}USDT",
  消息: "Informazione",
  滚球: "Palla rotante",
  是: "sì",
  不是: "no",
  当前余额: "bilancio corrente",
  KOL招募: "Reclutamento KOL",
  本月净输赢: "Vincita/perdita netta per il mese",
  本月佣金: "commissione del mese",
  佣金比例: "tasso di commissione",
  活跃人数: "numero attivo",
  新增下级: "Aggiungi subordinato",
  登录人数: "numero di accessi",
  首存人数: "Numero di primi depositanti",
  数据分析: "analisi dei dati",
  人数: "numero di persone",
  新注册存款金额: "Nuovo importo del deposito registrato",
  老用户存款金额: "Importo del deposito del vecchio utente",
  首存金额: "Importo del primo deposito",
  快捷入口: "Ingresso rapido",
  成员管理: "gestione dei membri",
  财务报表: "Bilancio d'esercizio",
  分红报表: "Rapporto sui dividendi",
  订单记录: "registrazione dell'ordine",
  VIP专享: "Esclusiva VIP",
  推广工具: "strumento di promozione",
  计算规则: "Regole di calcolo",
  账变明细: "Dettagli sulla modifica dell'account",
  成员: "membro",
  下级概览: "Panoramica subordinata",
  下级成员总计: "Totale membri subordinati",
  本月新增: "nuovo questo mese",
  本月活跃会员: "Membro attivo del mese",
  今日活跃会员: "Membri attivi oggi",
  本月有效活跃: "attivo questo mese",
  活跃成员占比: "Proporzione di membri attivi",
  本月活跃: "attivo questo mese",
  今日活跃: "attivo oggi",
  下级成员: "Membro Junior",
  会员账号: "conto membro",
  统计时间: "Tempo di statistiche",
  筛选: "filtro",
  存款: "depositare",
  取款: "prelevare denaro",
  总输赢: "vittoria o perdita totale",
  是否有效用户: "È un utente valido",
  最近登录时间: "ora dell'ultimo accesso",
  否: "No",
  开始时间: "Tempo di partenza",
  结束时间: "Tempo scaduto",
  提取: "estratto",
  总盈亏: "profitti e perdite totali",
  净盈亏: "utile e perdita netti",
  分红: "dividendi",
  概览: "panoramica",
  月度详细数据: "Dati mensili dettagliati",
  未发放: "non emessi",
  活跃用户: "utente attivo",
  有效新增会员: "Aggiungi efficacemente nuovi membri",
  冲正后净输赢: "Vincita o perdita netta dopo il colore",
  上月结余: "Saldo del mese scorso",
  净输赢: "vittoria/perdita netta",
  "系统每日新加坡时间1:00更新一次报表":
    "Il sistema aggiorna il rapporto ogni giorno alle 1:00 ora di Singapore",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "I numeri positivi nei dati, le vincite e le perdite totali e le vincite e le perdite nette nel rapporto indicano il profitto dell'agente e i numeri negativi indicano la perdita dell'agente",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "I dati sulle commissioni vengono aggiornati ogni giorno e sono solo di riferimento, non l'effettivo standard di distribuzione delle commissioni",
  选择时间: "periodo di selezione",
  足球: "calcio",
  投注金额: "importo della scommessa",
  有效订单: "ordine valido",
  下级账户: "Conto subordinato",
  待成交: "trattativa in sospeso",
  下单金额: "Ammontare dell'ordine",
  订单内容: "contenuto dell'ordine",
  秒数: "secondi",
  联赛: "la Lega",
  队伍: "squadra",
  比赛时间: "Tempo di competizione",
  玩法: "come giocare",
  等级规则表: "Tabella delle regole di valutazione",
  等级: "grado",
  活跃会员: "membro attivo",
  最新活跃: "ultimo attivo",
  额外佣金: "commissione extra",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Lo standard di crescita e il sistema di ricompensa del livello corrispondente vengono implementati ogni mese e si può godere di un solo premio di livello.",
  渠道生成: "generazione del canale",
  创建: "creare",
  渠道名称: "nome del canale",
  注册人数: "numero di iscritti",
  浏览人数: "Spettatori",
  构建状态: "stato di costruzione",
  禁用: "Disabilitato",
  启用: "abilitare",
  查看: "Dai un'occhiata",
  创建渠道: "creare canale",
  创建成功: "creato con successo",
  操作成功: "Operazione riuscita",
  渠道详情: "Dettagli del canale",
  邀请码: "Codice invito",
  访问人数: "numero di visitatori",
  渠道地址: "indirizzo del canale",
  我的福利: "i miei benefici",
  充值福利: "Vantaggi di ricarica",
  当前流水: "flusso di corrente",
  如何参与: "come partecipare",
  币种充值: "Ricarica valuta",
  充值福利中领取福利: "Ricevi vantaggi dai vantaggi di ricarica",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regole: il vantaggio di ricarica è volontario da ricevere e il periodo di validità è entro 24 ore dalla ricarica.Non sarà valido dopo la data di scadenza.Dopo averlo ricevuto, la funzione di prelievo di contanti sarà temporaneamente bloccata e il prelievo di contanti può essere sbloccato dopo il raggiungimento del fatturato.",
  失效日期: "data di scadenza",
  "暂无福利领取，充值后领取":
    "Nessun vantaggio da ricevere ancora, ricevi dopo la ricarica",
  参与: "partecipare",
  充值赠送: "Ricarica regalo",
  "领取*%的赠送": "Ricevi il {0}% di regalo",
  去领取: "raccogliere",
  VIP奖励: "Premi VIP",
  "当前可领取*USDT，是否确认领取":
    "Può ricevere {0}USDT al momento, conferma la richiesta?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Dopo la richiesta, la funzione di prelievo sarà temporaneamente bloccata e il blocco può essere sbloccato quando il tuo fatturato raggiunge {0}USDT",
  充值送大礼: "Ricarica per ricevere un grande regalo",
  "存入越多，送越多！": "Più depositi, più ottieni!",
  无效: "non valido",
  有效: "efficiente",
  总存金额: "importo totale del deposito",
  提示: "suggerimento",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "I numeri positivi nelle vincite e nelle perdite totali e le vincite e le perdite nette indicano i profitti della piattaforma e i numeri negativi indicano le perdite.I dati giornalieri sono solo di riferimento e non servono come standard effettivo di distribuzione delle commissioni.",
  "净盈亏：总盈亏-用户返水":
    "Utile e perdita netti: profitti e perdite totali - sconto utente",
  盈利方: "Festa redditizia",
  代理: "recitazione",
  客户: "cliente",
  平局: "disegnare",
  平台: "piattaforma",
  "已提交审核，请耐心等待": "Inviato per la revisione, si prega di pazientare",
  充值日期: "data di ricarica",
  平台本月总输赢: "Totale vittorie e sconfitte della piattaforma questo mese",
  KOL招募合作: "Cooperazione di reclutamento KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "La piattaforma è ora aperta [KOL Recruitment Event], purché tu abbia un account sui social media, puoi godere di un bonus una tantum con la piattaforma per promuovere i clienti e puoi godere di vantaggi per tutta la vita.",
  级别: "livello",
  平台利润返佣: "Sconto sui profitti della piattaforma",
  佣金案例: "Caso Commissione",
  交易项目: "elemento di transazione",
  "期权交易、合约交易、足球游戏":
    "Trading di opzioni, trading di contratti, partite di calcio",
  报名方式: "modalità di registrazione",
  点击KOL招募报名: "Fare clic sulla registrazione del reclutamento KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Benvenuto a far parte del nostro team, la piattaforma ti supporta completamente per stabilire il tuo sistema utente e puoi ottenere la commissione più alta{0}, non vediamo l'ora che tu ti unisca.",
  输入联系方式: "Inserisci le informazioni di contatto",
  最低活跃人数: "Numero minimo attivo",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Ad esempio: il numero di utenti attivi questo mese ≥ {0} e la vincita o la perdita totale della piattaforma questo mese ≥ {1}USDT, appartieni al livello {2}, puoi ottenere {3}% di commissione.",
  比分竞猜: "Quiz sul punteggio",
  豪礼相赠: "Regalo",
  足球活动: "Attività calcistica",
  圣诞节活动: "Attività natalizie",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Hai partecipato all'attività e bloccato temporaneamente la funzione di prelievo. Hai bisogno di {0} USDT flow per sbloccarla.",
  剩余流水: "Acqua residua",
  助力足球: "Boost football",
  佣金累计: "Commissione totale",
  有效投注: "Scommessa valida",
  今日: "Oggi",
  今日返水: "Sconto oggi",
  VIP返水: "Sconto VIP",
  返水记录: "Record di sconto",
  成员信息: "Informazioni sui membri",
  基本信息: "Informazioni di base",
  钱包余额: "Saldo del portafoglio",
  投注信息: "Informazioni sulle scommesse",
  返水: "Sconto",
  总下注: "Puntata totale",
  今日输赢: "Vincere o perdere oggi",
  下注动态: "Dinamica delle scommesse",
  返水奖励: "Bonus sconto",
  分红金额: "Importo del dividendo",
  返水支出: "Pagamento del rimborso",
  总返水: "Rimborso totale",
  流水总额: "Ricambio totale",
  返水总额: "Sconto totale",
  返水详情: "Dettagli sconto",
  日流水: "Acqua quotidiana",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "La piattaforma fornisce ricompense aggiuntive in base al fatturato giornaliero del tuo subordinato e le ricompense verranno distribuite sul conto premi ogni giorno alle 00:00 ora di Singapore",
  "申请成功，等待审核":
    "L'applicazione è andata a buon fine, in attesa di revisione",
  "我出本金，盈利共分享": "Pago il capitale e condivido i profitti",
  最高分红: "dividendo più alto",
  投资大师比赛: "Concorso Master per gli investimenti",
  "我出本金，你盈利": "Io pago il capitale, tu guadagni",
  共分享: "condivisa",
  最高分红可得: "Dividendi massimi disponibili",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Sono in arrivo vantaggi esclusivi per i nuovi utenti, ${0} gratuiti, puoi investire in qualsiasi progetto sulla piattaforma dopo averlo ricevuto e puoi ritirarlo immediatamente dopo aver realizzato un profitto.",
  报名领取: "Iscriviti per ricevere",
  已领取: "ricevuto",
  审核驳回: "Recensione respinta",
  驳回原因: "Motivo del rifiuto",
  活动运行周期: "Ciclo di esecuzione dell'attività",
  "申请成功后起至*天内完成超额收益。":
    "Dopo che la domanda è andata a buon fine, il reddito in eccesso sarà completato entro {0} giorni.",
  分红比: "Rapporto dividendo",
  "*日获得盈利后，可获得*%的收益额。":
    "Dopo aver guadagnato il profitto il {0} giorno, puoi ottenere {1}% del profitto.",
  参与条件: "Condizioni di partecipazione",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Gli utenti in Russia e Turchia non hanno partecipato.",
  计算项目: "voce di calcolo",
  "合约、体育、期权": "Contratti, Sport, Opzioni",
  我的投资: "il mio investimento",
  参与天数: "Giornate di partecipazione",
  累计下注: "scommessa cumulativa",
  累计盈亏: "Profitti e perdite accumulati",
  预计可分红: "Si prevede di pagare dividendi",
  常见问题: "problema comune",
  什么是平台出资: "Cos'è il finanziamento della piattaforma",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Secondo gli utenti di alcuni paesi, la piattaforma fornisce fondi gratuiti agli utenti da investire in progetti.",
  怎么获取平台出资的福利:
    "Come ottenere i benefici del contributo della piattaforma",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Devi solo essere un utente in un paese designato, fare clic sul pulsante di registrazione in alto e {0} USDT verrà trasferito sul conto bounty sotto l'account corrente dopo che la revisione della piattaforma è stata completata e puoi trasferirlo su altri conti per l'investimento.",
  什么是分红: "cos'è il dividendo",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividendo significa che entro un determinato periodo di tempo, dopo che il reddito raggiunge il 100%, può essere distribuito il 50% del reddito in eccesso. Ad esempio: per ricevere fondi da 100 USDT, l'importo del reddito è del 120%.",
  "如何取得分红？": "Come ottenere i dividendi?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Il ciclo di attività è una volta ogni {0}giorno. Al termine dell'attività, verrà calcolato e i dividendi verranno distribuiti sul conto bounty dopo aver soddisfatto i requisiti dell'attività. Se non soddisfi i requisiti di attività, il sistema cancellerà automaticamente le tue entrate e i contributi alla piattaforma.",
  活动规则: "Regole di attività",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Gli account partecipanti devono essere sottoposti a verifica KYC e ogni account è limitato a un vantaggio.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "Il KYC degli account partecipanti richiede la partecipazione del paese specificato e le altre regioni non sono autorizzate a partecipare. Controlla se il paese attivo è coerente con il tuo paese.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Dopo aver partecipato con successo all'attività, l'account bloccherà temporaneamente la funzione di prelievo e la funzione di prelievo verrà rilasciata al termine dell'attività.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Si prega di rispettare le regole di attività della piattaforma.Se trovi barare o sfruttare scappatoie del sistema a scopo di lucro, la piattaforma bloccherà tutti i fondi sul tuo account per un lungo periodo.",
  平台出资: "Investimento della piattaforma",
  平台出资收回: "Recupero dell'investimento della piattaforma",
  投资大师奖励: "Premio Master per gli investimenti",
  请下载APP添加收款方式:
    "Si prega di scaricare l'APP per aggiungere un metodo di pagamento",
  请下载APP进行身份验证:
    "Si prega di scaricare l'APP per la verifica dell'identità",
  请下载APP参与: "Scarica l'APP per partecipare",
  技术指标: "技术指标",
  主图: "Principale",
  副图: "Secondaria",
  新注册人数: "Nuovi iscritti",
  老用户存款人数: "Vecchi depositi utente",
  存款人数: "Numero di depositanti",
  取款人数: "Numero di prelievi",
  投注人数: "Numero di scommettitori",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Tranne Indonesia, India, Bangladesh e utenti che non hanno partecipato.",
  市场动态: "Dinamiche di mercato",
  外汇合约: "contratto di cambio",
  盈亏比: "rapporto profitti-perdite",
  委托价: "Prezzo dell'ordine",
  可用余额: "saldo disponibile",
  持仓额: "Importo della posizione",
  强平价: "Parità forte",
  修改: "Rivedere",
  修改价位: "Modifica prezzo",
  外汇: "Forex",
  外汇账户: "Conto Forex",
  我的交易: "la mia transazione",
  未设置: "non impostato",
  超出最大可设数值: "Supera il valore massimo impostabile",
  超出最小可设数值: "Supera il valore minimo impostabile",
  止盈超出最小可设数值: "Il take profit supera il valore minimo impostabile",
  止损超出最大可设数值: "Lo stop loss supera il valore massimo impostabile",
  止盈超出最大可设数值: "Il take profit supera il valore massimo impostabile",
  止损超出最小可设数值: "Lo stop loss supera il valore minimo impostabile",
  挖矿: "Estrazione",
  交易账户: "conto delle transazioni",
  买涨: "Acquista",
  买跌: "Compra o vendi",
  请输入正确的银行卡信息: "Inserisci i dati corretti della carta bancaria",
  联系在线客服: "Contatta il servizio clienti online",
  法币交易请联系在线客服:
    "Per transazioni in valuta legale, contattare il servizio clienti online",
  提交订单: "Inviare ordine",
  "支付过程如有疑问,请联系在线客服":
    "In caso di domande sulla procedura di pagamento, contattare il servizio clienti online",
  彩金赠送: "Regalo della lotteria",
  在线客服: "Servizio Online",
  最少投资: "investimento minimo",
  "提交时间:": "Orario di invio:",
  提现拒绝: "Ritiro respinto",
  认证拒绝: "Autenticazione rifiutata",
  认证通过: "Certificazione superata",
  请输入正确的交易额度: "Inserisci l'importo corretto della transazione",
  最大下注金额: "Importo massimo della scommessa",
  手机号: "Numero di telefono",
  邮箱注册: "registrazione email",
  手机号注册: "Registrazione del numero di cellulare",
  查询: "Chiedere informazioni",
  手机号登录: "Accesso tramite numero di cellulare",
  邮箱登录: "E-mail di accesso",
  请输入数量: "Inserisci la quantità",
  可用数量: "quantità disponibile",
  钱包登录: "Accesso al portafoglio",
  请输入正确的邀请码: "Inserisci il codice invito corretto",
  "请输入邀请码(必填)": "Per favore inserisci il codice invito (richiesto)",
  输入正确的金额: "Inserisci l'importo corretto",
  法币充值: "ricarica con valuta nazionale",
  卢比充值: "Ricarica in rupie",
  请输入法币: "Inserisci valuta legale",
  请输入IFSC: "Inserisci IFSC",
  "银行编码(选填)": "Codice bancario (opzionale)",
  请输入银行编码: "Inserisci il codice bancario",
  请输入大于8位数的密码: "Inserisci una password più lunga di 8 cifre",
  添加成功: "Aggiunto con successo",
  "60秒": "60 secondi",
  "180秒": "180 secondi",
  "300秒": "300 secondi",
  "2次密码不一致": "2 password non sono coerenti",
  输入提币数量: "Inserisci l'importo del prelievo",
  图片格式不正确: "Formato dell'immagine non corretto",
  图片大于20M: "L'immagine è più grande di 20 MB",
  请设置委托价格: "Si prega di impostare il prezzo della commissione",
  输入资金密码: "Inserisci la password del fondo",
  验证码错误: "Errore nel codice di verifica",
  充值拒绝: "Ricarica rifiutata",
  请输入SSN: "Inserisci il SSN",
  合约交易: "negoziazione a contratto",
  结算完成: "Regolamento completato",
  继续下单: "Continua ad ordinare",
  最低购买: "acquisto minimo",
  最高购买: "acquisto più alto",
  限价: "Prezzo Limite",
  买入价格: "Prezzo di Acquisto",
  买入量: "Quantità di Acquisto",
  卖出价格: "Prezzo di Vendita",
  卖出量: "Quantità di Vendita",
  买入: "Acquista",
  卖出: "Vendi",
  订单创建成功: "Ordine Creato con Successo",
  币币买入支出: "Spesa di Acquisto di Cripto",
  币币买入支出退还: "Rimborso della Spesa di Acquisto di Cripto",
  币币买入获得: "Cripto Ricevuta da Acquisto",
  币币卖出支出: "Spesa di Vendita di Cripto",
  币币卖出支出退还: "Rimborso della Spesa di Vendita di Cripto",
  币币卖出获得: "Cripto Ricevuta da Vendita",
  币币交易手续费: "Commissione di Transazione Cripto",
  请输入限价: "Si Prega di Inserire il Prezzo Limite",
  成交: "Completato",
  等待成交: "In Attesa di Completamento",
  交易完成: "Transazione Completata",
  被取消: "Annullato",
  交易时间: "Orario della Transazione",
  法币交易: "Scambio di valuta fiduciaria",
  法币出售: "Vendita di valuta fiduciaria",
  两次密码不一致: "Le due password non corrispondono",
  再次输入账户密码: "Reinserisci la password dell’account",

  美国: "U.S.A.",
  韩国: "Corea del Sud",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Yemen",
  美属维尔京群岛: "US Virgin Isole",
  英属处女群岛: "Isole Vergini britanniche",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "REGNO UNITO.",
  阿拉伯联合酋长国: "Emirati Arabi Uniti",
  乌克兰: "Ucraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Isole Turks e Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Türkiye",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad e Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Timor Est",
  泰国: "Thailandia",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tajikistan",
  中国台湾: "Taiwan, Cina",
  叙利亚: "Siria",
  瑞士: "Svizzera",
  瑞典: "Svezia",
  斯威士兰: "Swaziland",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spagna",
  南非: "Sudafrica",
  索马里: "Somalia",
  所罗门群岛: "Isole Salomone",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovacchia",
  "圣马丁岛（荷兰部分）": "Saint Martin (parte olandese)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Arabia Saudita",
  圣多美和普林西比: "Sao Tome e Principe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "San Christopher e Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent e Grenadines",
  圣彼埃尔和密克隆岛: "St. Pierre e Miquelon Island",
  圣露西亚: "St. Lucia",
  圣基茨和尼维斯: "St. Kitts e Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Russia",
  罗马尼亚: "Romania",
  留尼汪: "Riunione",
  刚果共和国: "Repubblica del Congo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portogallo",
  波兰: "Polonia",
  菲律宾: "Le Filippine",
  秘鲁: "Perù",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Nuova Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norvegia",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Nuova Zelanda",
  新喀里多尼亚: "Nuova Caledonia",
  荷属安德列斯群岛: "I Paesi Bassi Andres Isole",
  荷兰: "Paesi Bassi",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambico",
  摩洛哥: "Marocco",
  蒙特塞拉特岛: "Montserrat Island",
  黑山: "Montenegro",
  蒙古: "Mongolia",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldavia",
  墨西哥: "Messico",
  马约特: "Mayot",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Isole mariana",
  马提尼克: "Martinica",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldive",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagascar",
  马其顿: "Macedonia",
  中国澳门: "Macao, Cina",
  卢森堡: "Lussemburgo",
  立陶宛: "Lituania",
  列支敦士登: "Liechtenstein",
  利比亚: "Libia",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libano",
  拉脱维亚: "Lettonia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirghizistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakistan",
  约旦: "Giordania",
  日本: "Giappone",
  牙买加: "Giamaica",
  象牙海岸: "Costa d'Avorio",
  意大利: "Italia",
  以色列: "Israele",
  爱尔兰: "Irlanda",
  伊拉克: "Iraq",
  伊朗: "Iran",
  印度尼西亚: "Indonesia",
  印度: "India",
  冰岛: "Islanda",
  匈牙利: "Ungheria",
  中国香港: "Hong Kong, Cina",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Repubblica della Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Greneda",
  格陵兰岛: "Groenlandia",
  希腊: "Grecia",
  直布罗陀: "Gibilterra",
  加纳: "Ghana",
  德国: "Germania",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Polinesia francese",
  法属圭亚那: "Guyana francese",
  法国: "Francia",
  芬兰: "Finlandia",
  斐济: "Figi",
  法罗群岛: "Isole Faroe",
  埃塞俄比亚: "Etiopia",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Guinea equatoriale",
  萨尔瓦多: "El Salvador",
  埃及: "Egitto",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Repubblica Dominicana",
  多米尼加: "Dominicano",
  吉布提: "Djibouti",
  丹麦: "Danimarca",
  捷克: "Repubblica ceca",
  塞浦路斯: "Cipro",
  库拉索: "Curacao",
  古巴: "Cuba",
  克罗地亚: "Croazia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Costa d'Ivoire",
  库克群岛: "Isole di cuocere",
  科摩罗: "COMOROS",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Chad",
  中非共和国: "Repubblica centrafricana",
  佛得角: "Cape Verde",
  开曼群岛: "Isole Cayman",
  开普: "Kaipu",
  加拿大: "Canada",
  喀麦隆: "Camerun",
  柬埔寨: "Cambogia",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brasile",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia ed Erzegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Isole Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgio",
  白俄罗斯: "Bielorussia",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrein",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbaigian",
  奥地利: "Austria",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua e Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Samoa americana",
  阿尔及利亚: "Algeria",
  中国: "Cina",

  日收益: "Profitto giornaliero",
  "30天预期收益": "Profitto previsto per 30 giorni",
  英伟达高速矿机: "Miniera ad alta velocità NVIDIA",
  去投资: "Andare a investire",
  新币榜: "Classifica delle nuove monete",
  主题: "Tema",
  立即探索: "Esplora subito",
  等您来: "Vi aspettiamo",
  最新活动: "Ultime attività",
  货币划转: "Trasferimento di valuta",
  提现钱包: "Portafoglio di prelievo",
  加密合约: "Contratto crittografico",
  外汇期货: "Futures di valuta estera",
  定期: "A termine fisso",
  探索产品: "Esplora i prodotti",
  稳健型: "Tipo conservativo",
  高收益: "Alto rendimento",
  期货账户: "Conto futures",
  时间线: "Timeline",
  收藏: "Preferiti",
  委托订单: "Ordine di commissione",
  最新交易: "Ultime transazioni",
  深度图: "Grafico di profondità",
  标记价格: "Prezzo indicativo",
  "24h最高价": "Prezzo massimo in 24h",
  "24h成交量": "Volume di negoziazione in 24h",
  "24h最低价": "Prezzo minimo in 24h",
  "24h成交额": "Importo di negoziazione in 24h",
  "价格(USDT)": "Prezzo (USDT)",
  "数量(ETH)": "Quantità (ETH)",
  看空: "Posizione corta",
  余额不足: "Saldo insufficiente",
  最低购买: "Acquisto minimo",
  最高购买: "Acquisto massimo",
  下单成功: "Ordine effettuato con successo",
  平仓成功: "Chiusura posizione riuscita",
  请输入正确的平仓数量:
    "Inserisci la quantità corretta per la chiusura posizione",
  加仓成功: "Aumento posizione riuscito",
  请输入正确的加仓金额: "Inserisci l'importo corretto per l'aumento posizione",
  收藏成功: "Aggiunto ai preferiti con successo",
  取消收藏成功: "Rimosso dai preferiti con successo",
  日收益率: "Tasso di rendimento giornaliero",
  轻松理财: "Gestione del patrimonio semplice",
  立即申购: "Sottoscrivi subito",
  申购日期: "Data di sottoscrizione",
  加密货币: "Valuta crittografica",
  交割合约: "Contratto di consegna",
  最小投资: "Investimento minimo",
  委托: "Commissione",
  "当指数价格触达时，将会触发委托平仓":
    "Quando il prezzo dell'indice viene raggiunto, verrà attivata la chiusura posizione di commissione",
  预计盈利: "Profitto previsto",
  最大投资: "Investimento massimo",
  现货交易: "Trading crypto",
  输入交易金额: "Inserisci l'importo della transazione",
  "可用额度：": "Limite disponibile:",
  提现货币: "Valuta di prelievo",
  期货合约: "Contratto futures",
  加密币永续: "Perpetuo cripto",
  外汇永续: "Perpetuo Forex",
  期权账户: "Conto opzioni",
  夜间模式: "Modalità notturna",
  未结盈亏: "Guadagni e perdite non realizzati",
  超额收益: "Guadagni in eccesso",
  "安全策略，低买高卖": "Strategia di sicurezza, acquisti bassi",
  投资金额应为: "L'importo dell'investimento deve essere",
  总收益率: "Rendimento totale",
  赎回成功: "Riscatto riuscito",
  快捷卖币: "Vendita rapida",
  修改止盈止损: "Modifica TP/SL",
  白皮书: "Libro bianco",

  托管资金: "Fondi in gestione",
  托管中: "In gestione",
  预计日收益: "Guadagno giornaliero stimato",
  累计收益: "Guadagni totali",
  周期: "Periodo",
  日收益: "Guadagno giornaliero",
  限额: "Limite",
  立即托管: "Investi ora",
  "已鎖定 請聯繫客服": "Bloccato, contatta l’assistenza clienti",
  产品列表: "Elenco prodotti",
  规则: "Regole",
  创建订单: "Crea ordine",
  产品名称: "Nome prodotto",
  托管周期: "Periodo di gestione",
  等级限制: "Restrizione di livello",
  托管金额: "Importo investimento",
  限额: "Limite",
  余额: "Saldo",
  购买日: "Data di acquisto",
  起息日: "Data di inizio interessi",
  派息时间: "Orario di distribuzione dei profitti",
  每天: "Ogni giorno",
  计息结束日: "Data di fine interessi",
  每日收益: "Guadagno giornaliero",
  预计收益: "Guadagno stimato",
  "收益将自动发送至您的余额账户;":
    "I profitti saranno inviati automaticamente al tuo conto saldo;",
  "您的资金没有任何风险;": "I tuoi fondi non sono soggetti a rischi;",
  "365*24小时不断地工作;": "Funziona 24 ore su 24, 365 giorni all’anno;",
  托管中: "In gestione",
  结束: "Terminato",
  今日收益: "Guadagno di oggi",
  剩余周期: "Periodo rimanente",
  进行中: "In corso",
  已发放: "Pagato",
  信誉分: "Punti reputazione",

  复制成功: "Copiato con successo",
  VIP权益: "Vantaggi VIP",
  旧密码: "Vecchia password",
  请输入旧密码: "Inserisci la vecchia password",
  "忘记旧密码请联系客服重置。":
    "Se hai dimenticato la vecchia password, contatta l'assistenza clienti per reimpostarla.",
  去升级: "Aggiorna",
  描述: "Descrizione",
  实际存款金额: "Importo effettivo del deposito",
  升级礼金: "Bonus di aggiornamento",
  隔夜利息: "Interessi overnight (swap)",
  自动结算: "Liquidazione automatica",
  等级规则: "Regole del livello",
  "WEB3.0币持有数据收益": "Rendimento dei dati di detenzione di monete WEB3.0",
  总生产: "Produzione totale",
  有效节点: "Nodi attivi",
  参与人: "Partecipanti",
  用户收益: "Rendimento per l'utente",
  "流动性WEB3.0输出": "Output di liquidità WEB3.0",
  总资产: "Attività totali",

  ETHAI持有数据收益: "Rendimento dei dati di detenzione ETHAI",
  AI量化流动性: "Liquidità quantitativa IA",
  现货买入手续费: "Commissione di acquisto spot",
  现货支出: "Spesa spot",
  现货资金费率: "Tasso di finanziamento spot",
  现货卖出手续费: "Commissione di vendita spot",
  现货收入: "Entrata spot",
  外汇合约支出: "Spesa del contratto forex",
  外汇合约买入手续费: "Commissione di acquisto del contratto forex",
  外汇合约资金费率: "Tasso di finanziamento del contratto forex",
  外汇合约卖出手续费: "Commissione di vendita del contratto forex",
  外汇合约收入: "Entrata del contratto forex",
  理财购买: "Acquisto di prodotto finanziario",
  VIP理财日收益: "Rendimento giornaliero del prodotto finanziario VIP",
  VIP理财隔夜利息: "Interesse overnight del prodotto finanziario VIP",
  VIP本金返还: "Rimborso del capitale VIP",
  VIP彩金发放: "Distribuzione del bonus VIP",
  VIP彩金抵扣: "Detrazione del bonus VIP",
  隔夜利息: "Interesse overnight",
  设置资产密码: "Imposta password degli asset",

  锁仓挖矿: "Mining con blocco",
  一站式理财服务: "Servizio finanziario tutto-in-uno",
  产品: "Prodotti",
  客服中心: "Centro assistenza clienti",
  贷款: "Prestiti",
  挖矿赚不停: "Guadagna continuamente dal mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Il mining con blocco consiste nell'affidare USDT (USD:1USDT=1USD) ai dispositivi di mining ad alta potenza della piattaforma per ottenere rendimenti nel pool di mining della piattaforma.",
  产品优势: "Vantaggi del prodotto",
  随存随取: "Deposito e prelievo flessibili",
  锁仓周期: "Periodo di blocco",
  每日下发: "Distribuzione giornaliera",
  随机空投: "Airdrop casuale",
  "100%资金安全保障": "Garanzia di sicurezza dei fondi al 100%",
  "100%节假日收益不间断":
    "Rendimenti continui al 100% anche nei giorni festivi",
  成功锁仓后当天产出:
    "Rendimenti generati lo stesso giorno dopo il blocco riuscito",
  关于违约金: "Informazioni sulla penale",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Se desideri prelevare il capitale prima della scadenza, verrà applicata una penale. Penale = tasso di penale × giorni rimanenti × importo bloccato.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Esempio: il tasso di penale di questo prodotto di mining con blocco è del 5%, mancano 3 giorni alla scadenza e l'importo bloccato è 10000U (USDT/USD). La penale = 5%×3×10000=1500U, quindi il capitale effettivamente restituito è 15000U-1500U.",
  收益计算: "Calcolo dei profitti",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "La piattaforma offre diversi prodotti finanziari di mining con blocco. Il calcolo dei profitti è il seguente, ad esempio:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Se un utente blocca 10000U (USDT, USD) sulla piattaforma e sceglie un prodotto di 7 giorni con rendimento giornaliero dello 0,7%~1,8% dell'importo bloccato, il guadagno giornaliero sarà il seguente:",
  "最低:10000Ux0.7%=70U;": "Minimo: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Massimo: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Dopo 7 giorni è possibile ottenere un guadagno di 490U~1260U. I profitti vengono distribuiti giornalmente e il capitale bloccato viene trasferito automaticamente sul tuo conto alla scadenza.",
  正在托管的资金: "Fondi in gestione",
  签到: "Check-in",
  锁仓订单: "Ordini di blocco",
  预计今日收益: "Guadagni stimati di oggi",
  累计收益: "Guadagni cumulativi",
  托管中的订单: "Ordini in gestione",
  单笔最少: "Importo minimo per ordine",
  单笔最多: "Importo massimo per ordine",
  日收益率: "Rendimento giornaliero",
  说明: "Descrizione",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. I dati sono basati sul fuso orario GMT+8<br>2. I guadagni giornalieri sono calcolati su tutti gli ordini regolati tra le 00:00 e le 23:59 GMT+8 (ora locale 00:00-23:59)<br>3. I guadagni del giorno vengono distribuiti il giorno successivo tra le 00:00 e le 00:10 GMT+8.",
  知道了: "Capito",
  锁仓: "Blocca",
  派息时间: "Orario di distribuzione",
  每日: "Giornaliero",
  托管资金: "Fondi in custodia",
  到期返回: "Ritorno a scadenza",
  提前赎回: "Riscatto anticipato",
  预计收益: "Guadagno stimato",
  认购: "Sottoscrizione",
  热门: "Popolare",
  数字货币: "Criptovalute",
  贵金属: "Metalli preziosi",
  大宗商品: "Materie prime",
  持仓明细: "Dettagli posizione",
  历史明细: "Storico",
  当前价: "Prezzo attuale",
  "↑买涨": "↑ Compra rialzo",
  "↓买跌": "↓ Compra ribasso",
  显示全部: "Mostra tutto",
  买入金额: "Importo acquisto",
  方向: "Direzione",
  收益: "Profitto",
  预期收益: "Profitto atteso",
  估用保证金: "Margine stimato",
  确认下单: "Conferma ordine",
  锁定: "Bloccato",
  账户总资产: "Totale asset conto",
  明细: "Dettagli",
  今日收益: "Guadagni di oggi",
  仓位保证金: "Margine posizione",
  持有仓位: "Posizioni aperte",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Importo bloccato = somma di tutti gli ordini di mining con blocco non completati",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. I dati sono basati su GMT+8<br>2. I guadagni giornalieri sono calcolati su tutti gli ordini regolati tra le 00:00 e le 23:59 GMT+8 (ora locale 00:00-23:59)",
  充值方式: "Metodo di deposito",
  银行汇款: "Bonifico bancario",
  "银行汇款请联系客服进行操作!":
    "Contatta il servizio clienti per il bonifico bancario!",
  提款方式: "Metodo di prelievo",
  "银行提款请联系客服进行操作!":
    "Contatta il servizio clienti per il prelievo bancario!",
  资金明细: "Dettagli fondi",
  提现记录: "Storico prelievi",
  拒绝: "Rifiutato",
  通过: "Approvato",
  拒绝原因: "Motivo del rifiuto",

  消息公告: "Annunci",
  订单: "Ordini",
  个人中心: "Centro personale",
  "未到期赎回需支付一定的违约金!":
    "Il rimborso anticipato comporta il pagamento di una penale.",

  请输入区号: "Inserisci il prefisso",
  "请选择国家/地区": "Seleziona un paese/regione",

  今日开盘: "Apertura di oggi",
  昨日收盘: "Chiusura di ieri",

  实名认证即送: "Ricevi immediatamente dopo la verifica dell'identità",
  立即认证: "Verifica ora",
  新用户礼包: "Pacchetto regalo per nuovi utenti",
  完成新人任务领取: "Completa le attività per i nuovi utenti per riscattarlo",
  认证: "Verifica",
  时间周期: "Periodo di tempo",
  支付金额: "Importo del pagamento",
  已平仓: "Chiuso",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Pacchetto di benvenuto MGBX per nuovi utenti: ogni utente può ricevere al massimo",
  我已经阅读并同意: "Ho letto e accetto",
  隐私政策: "Informativa sulla privacy",

  放弃奖励离开: "Rinuncia alla ricompensa ed esci",
  继续注册: "Continua la registrazione",
  分钟: "Minuti",

  "请先勾选隐私政策!":
    "Si prega di consultare prima l'Informativa sulla privacy!",

  添加其他到自选: "Aggiungi altri alla lista di controllo",
  充值最高可得: "Effettua una ricarica e ottieni fino a 30.000 $.",

  请输入格式正确的手机号: "Inserisci un numero di cellulare valido.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 意大利语



// WEBPACK FOOTER //
// ./src/lang/it.js